/*
 * Schuifbalk onder een horizontale slider.

 * Begonnen in het winkelmandje, inmiddels ook op de productpagina: elke lijst
 * met data-sliderbar erop krijgt er een. Opt-in via de opmaak en niet via een
 * lijstje klassen hier, zodat een nieuwe slider zichzelf aanmeldt in plaats van
 * dat dit bestand van elke pagina moet weten.
 *
 * De sliders verbergen de eigen scrollbalk van de browser -- die staat er op
 * elke computer anders uit en past niet bij de rest. Het gevolg is dat op
 * desktop niets verraadt dat er meer kaarten staan: er is geen veeg, en een
 * muiswiel scrolt niet zijwaarts.
 *
 * Deze balk doet daarom twee dingen tegelijk: laten zien waar je bent, en de
 * bediening zijn. De duim is te slepen en je kunt op de baan klikken om te
 * springen.
 *
 * De balk wordt hier gemaakt en niet in Liquid, want de kaarten van de tweede
 * slider komen ook uit JavaScript. Een balk in de opmaak zou daar op het
 * verkeerde moment bestaan.
 */
(function () {
  var KLASSE = 'cd-sliderbar';

  function setup(list) {
    if (!list || list.dataset.sliderbar === 'on') return;
    list.dataset.sliderbar = 'on';

    var bar = document.createElement('div');
    bar.className = KLASSE;
    /*
     * aria-hidden: dit dupliceert het scrollen dat de browser al kan. Een
     * schermlezer of toetsenbordgebruiker bereikt de kaarten met Tab, en dan
     * schuift de lijst vanzelf mee.
     */
    bar.setAttribute('aria-hidden', 'true');

    var thumb = document.createElement('span');
    thumb.className = KLASSE + '__thumb';
    bar.appendChild(thumb);

    list.parentNode.insertBefore(bar, list.nextSibling);

    /*
     * De afmetingen van de lijst onthouden we. Ze opvragen dwingt de browser de
     * pagina opnieuw op te meten, en dat wil je niet tientallen keren per
     * seconde tijdens het scrollen.
     */
    var breedte = 0;
    var inhoud = 0;

    function meet() {
      breedte = list.clientWidth;
      inhoud = list.scrollWidth;

      /* Niets te schuiven? Dan is een schuifbalk misleidend. */
      if (inhoud - breedte <= 4) {
        bar.hidden = true;
        return false;
      }

      bar.hidden = false;
      thumb.style.width = ((breedte / inhoud) * 100).toFixed(2) + '%';
      return true;
    }

    function volg() {
      if (bar.hidden || !inhoud) return;
      thumb.style.left = ((list.scrollLeft / inhoud) * 100).toFixed(2) + '%';
    }

    function update() {
      if (meet()) volg();
    }

    /*
     * Rechtstreeks bij het scrollen, zonder te wachten op een beeldopfrissing.
     * Met de afmetingen in het geheugen is dit een deling en een stijlregel --
     * goedkoper dan het opzetten van die wachtrij.
     *
     * Eerder stond hier wel zo'n wachtrij, met een vlag die alleen ín de
     * opfrissing omlaag ging. Bleef die uit, bijvoorbeeld in een tabblad op de
     * achtergrond, dan bevroor de balk voorgoed.
     */
    list.addEventListener('scroll', volg, { passive: true });

    if (window.ResizeObserver) {
      new window.ResizeObserver(update).observe(list);
    } else {
      window.addEventListener('resize', update);
    }

    /* ------------------------------------------------------------- slepen -- */

    var sleept = false;
    var rustig = window.matchMedia('(prefers-reduced-motion: reduce)');

    /*
     * Tijdens het slepen zetten we het vastklikken uit. De lijst heeft
     * scroll-snap-type: x mandatory, en die trekt elke positie meteen naar de
     * dichtstbijzijnde kaart -- daardoor sprong de duim van kaart naar kaart in
     * plaats van je vinger te volgen.
     *
     * Bij het loslaten zetten we het terug, en dan glijdt de lijst vanzelf naar
     * de dichtstbijzijnde kaart. Dat is meteen de nette afronding van de veeg.
     */
    function snapUit() {
      list.style.scrollSnapType = 'none';
    }

    function snapAan() {
      list.style.scrollSnapType = '';
    }

    function scrollNaar(clientX, zacht) {
      var vak = bar.getBoundingClientRect();
      if (!vak.width) return;

      var duimBreedte = thumb.getBoundingClientRect().width;
      /*
       * De duim volgt zijn midden, niet zijn linkerrand: pak je hem in het
       * midden beet, dan hoort hij daar te blijven en niet weg te springen.
       */
      var positie = (clientX - vak.left - duimBreedte / 2) / (vak.width - duimBreedte);
      positie = Math.min(Math.max(positie, 0), 1);

      var doel = positie * (list.scrollWidth - list.clientWidth);

      /*
       * Slepen volgt de vinger een-op-een; daar zou een animatie juist
       * achterlopen. Een klik op de baan is een sprong, en die mag glijden.
       */
      if (zacht && !rustig.matches && list.scrollTo) {
        list.scrollTo({ left: doel, behavior: 'smooth' });
      } else {
        list.scrollLeft = doel;
      }
    }

    /*
     * Elke druk op de balk begint een sleep, waar je hem ook pakt. Eerder keek
     * ik of je precies het duim-element raakte, maar de balk heeft een
     * onzichtbaar aanraakgebied van acht pixel boven en onder; klikte je daar,
     * dan raakte je de baan en sprong hij in plaats van te slepen -- terwijl de
     * handcursor zei dat je beet had. Zit je naast de duim, dan schuift hij
     * eerst naar je aanwijzer en loopt daarna mee.
     */
    function beginSleep(event) {
      stopAnimatie();
      sleept = true;
      bar.classList.add('is-dragging');
      snapUit();

      var duim = thumb.getBoundingClientRect();
      var naastDeDuim = event.clientX < duim.left || event.clientX > duim.right;
      if (naastDeDuim) scrollNaar(event.clientX, false);

      /*
       * Tijdens het slepen luisteren we op het venster en niet op de balk. Je
       * beweegt bijna altijd even buiten die vier pixel hoogte, en dan zou de
       * beweging verloren gaan zodra de aanwijzer hem verlaat.
       */
      window.addEventListener('pointermove', tijdensSleep);
      window.addEventListener('pointerup', loslaten);
      window.addEventListener('pointercancel', loslaten);

      event.preventDefault();
    }

    function tijdensSleep(event) {
      if (!sleept) return;
      scrollNaar(event.clientX, false);
    }

    /*
     * Bij het loslaten vastklikken op de dichtstbijzijnde kaart, maar dan zelf
     * geanimeerd. Zou je alleen scroll-snap-type terugzetten, dan springt de
     * lijst er in een keer heen -- de browser animeert dat niet. En
     * scrollTo({behavior:'smooth'}) geeft geen grip op de duur; die kiest de
     * browser, en dat is voor dit doel te vlot.
     */
    var animatie = null;

    function stopAnimatie() {
      if (animatie) window.cancelAnimationFrame(animatie);
      animatie = null;
    }

    function dichtstbijzijndeKaart() {
      var lijstVak = list.getBoundingClientRect();
      var beste = null;
      var kleinste = Infinity;

      Array.prototype.forEach.call(list.children, function (kaart) {
        var verschil = kaart.getBoundingClientRect().left - lijstVak.left;
        if (Math.abs(verschil) < kleinste) {
          kleinste = Math.abs(verschil);
          beste = verschil;
        }
      });

      if (beste === null) return list.scrollLeft;

      var doel = list.scrollLeft + beste;
      return Math.min(Math.max(doel, 0), list.scrollWidth - list.clientWidth);
    }

    function glijNaar(doel, duur) {
      stopAnimatie();

      var start = list.scrollLeft;
      var afstand = doel - start;
      if (Math.abs(afstand) < 1) return;

      var begin = null;

      function stap(tijd) {
        if (begin === null) begin = tijd;

        var deel = Math.min((tijd - begin) / duur, 1);
        /* Snel op gang, zacht uitlopen -- zo zie je waar hij heen gaat. */
        var soepel = 1 - Math.pow(1 - deel, 3);

        list.scrollLeft = start + afstand * soepel;
        volg();

        if (deel < 1) {
          animatie = window.requestAnimationFrame(stap);
        } else {
          animatie = null;
          /* Pas terugzetten als hij stilstaat; anders vecht het met de animatie. */
          snapAan();
        }
      }

      animatie = window.requestAnimationFrame(stap);

      /*
       * Vangnet. Blijft de beeldopfrissing uit -- een tabblad op de achtergrond,
       * of een browser die hem wegbezuinigt -- dan loopt stap() nooit af en zou
       * het vastklikken uit blijven staan. Dan schuift de lijst voortaan vrij
       * rond in plaats van op kaarten te blijven staan.
       */
      window.setTimeout(function () {
        if (sleept) return;
        stopAnimatie();
        snapAan();
      }, duur + 150);
    }

    function loslaten() {
      if (!sleept) return;
      sleept = false;
      bar.classList.remove('is-dragging');

      window.removeEventListener('pointermove', tijdensSleep);
      window.removeEventListener('pointerup', loslaten);
      window.removeEventListener('pointercancel', loslaten);

      if (rustig.matches) {
        snapAan();
        return;
      }

      glijNaar(dichtstbijzijndeKaart(), 520);
    }

    bar.addEventListener('pointerdown', beginSleep);

    update();
  }

  function init() {
    document.querySelectorAll('.cd-upsell').forEach(setup);
    document.querySelectorAll('[data-sliderbar]').forEach(setup);
  }

  init();

  /*
   * Het winkelmandje vervangt zijn inhoud bij elke wijziging, en dan zijn de
   * lijsten nieuwe elementen zonder balk. Zie ook cart-match-slider.js.
   */
  document.addEventListener('sentir:cart:updated', init);
})();
